import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-au-react-components';

const StyledHeroBannerWithTitle = styled.div`
	@media (min-width: 576px) {
		height: ${(props) => (props.banner5050 ? 'auto' : '402px')};

		${(props) =>
			!props.banner5050 &&
			`
				background-image: url(${props.image});
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;
				position: relative;
			`}

		.container {
			height: 100%;
		}
	}

	.banner5050 {
		${EmotionBreakpoint('notMobile')} {
			background-color: ${(props) => props.overlayBackground || 'transparent'};
		}
	}
`;

const StyledHeroBannerWithTitleOverlay = styled.div`
	h2 {
		font-size: ${(props) => (props.titleFontSize || '40') + 'px'};
		line-height: ${(props) => (props.titleLineHeight || '48') + 'px'};
		letter-spacing: -0.5px;
		color: ${(props) => props.titleColor || '#212121'};

		${EmotionBreakpoint('mobile')} {
			font-size: 24px;
			line-height: 32px;
		}
	}

	p {
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: ${(props) => props.copyColor || '#212121'};
		max-height: 72px;
		overflow: hidden;
	}

	&.banner5050_content {
		${EmotionBreakpoint('notMobile')} {
			background-color: ${(props) => props.overlayBackground || 'transparent'};
		}

		> div {
			${EmotionBreakpoint('desktop')} {
				padding: 0 90px;
			}

			${EmotionBreakpoint('tablet')} {
				padding: 0 50px;
			}

			${EmotionBreakpoint('mobile')} {
				padding: 100px 40px;
			}
		}

		${EmotionBreakpoint('mobile')} {
			background-image: url(${(props) => props.mobileImage});
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
		}
	}

	&.overlay {
		@media (min-width: 576px) {
			background-color: ${(props) => props.overlayBackground || 'transparent'};
			position: absolute;
			left: 16px;
			top: 0;
			bottom: 0;
			margin: auto;
			width: 580px;
			height: 80%;
			padding: 0 40px;
		}

		@media (max-width: 575px) {
			padding: 20px;
			background-color: white;
		}

		${EmotionBreakpoint('tablet')} {
			width: 480px;
			left: 40px;
		}

		${EmotionBreakpoint('mobile')} and (min-width: 576px) {
			width: 350px;
			left: 40px;
		}
	}
`;

const StyledHeroBannerWithTitleImage = styled.div``;

function HeroBannerWithTitle({
	props: {
		title,
		titleColor,
		titleFontSize,
		titleLineHeight,
		copy,
		copyColor,
		buttonStyle,
		buttonCopy,
		buttonLink,
		overlayBackground,
		fullScreen,
		banner5050,
		bannerAlignment,
		image,
		imageUrl,
		imageMobile,
		imageUrlMobile,
	},
}) {
	let mainImage = imageUrl || null,
		mobileImage = imageUrlMobile || mainImage;

	if (!mainImage && image?.fields?.file?.url) {
		mainImage = image?.fields?.file?.url;
		mobileImage = image?.fields?.file?.url;
	}

	if (!mobileImage && imageMobile?.fields?.file?.url) {
		mobileImage = imageMobile?.fields?.file?.url;
	}

	let content = (
		<div
			className={`${
				banner5050
					? 'banner5050 d-md-flex align-items-center justify-content-start flex-equal'
					: ''
			} ${bannerAlignment ? ' flex-row-reverse' : ''}`}
		>
			<StyledHeroBannerWithTitleImage
				className={`${!banner5050 ? 'd-block d-sm-none' : 'd-none d-md-block'}`}
			>
				<img
					src={mobileImage}
					alt={title}
					title={title}
					className='mw-100 d-inline-block'
				/>
			</StyledHeroBannerWithTitleImage>
			<StyledHeroBannerWithTitleOverlay
				className={`d-flex justify-content-start align-items-center ${
					!banner5050 ? 'overlay' : 'banner5050_content'
				}`}
				overlayBackground={overlayBackground}
				mobileImage={mobileImage}
				titleColor={titleColor}
				copyColor={copyColor}
				titleFontSize={titleFontSize}
				titleLineHeight={titleLineHeight}
			>
				<div>
					{title && <h2 className='mb-0 lower'>{title}</h2>}
					{copy && <p className={title ? 'mt-16 mb-0' : ''}>{copy}</p>}
					{buttonLink && buttonCopy && (
						<div className={title || copy ? 'mt-20' : ''}>
							<a href={buttonLink} className={'btn btn-' + buttonStyle}>
								{buttonCopy}
							</a>
						</div>
					)}
				</div>
			</StyledHeroBannerWithTitleOverlay>
		</div>
	);

	if (fullScreen && !banner5050) {
		content = <div className='container position-relative'>{content}</div>;
	}

	content = (
		<StyledHeroBannerWithTitle
			image={mainImage}
			banner5050={banner5050}
			overlayBackground={overlayBackground}
		>
			{content}
		</StyledHeroBannerWithTitle>
	);

	if (!fullScreen) {
		content = <div className='container'>{content}</div>;
	}
	return content;
}

export default HeroBannerWithTitle;
